(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cf-klarna"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cf-klarna-info')) {
    customElements.define('cf-klarna-info', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.addEventListener('click', (event) => {
          const dialog = this.querySelector('dialog');
          if (!dialog) return;
          if (event.target.closest('.cf-klarna__open')) {
            event.preventDefault();
            event.stopPropagation();
            dialog.showModal();
            return;
          }
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        });
        this.addEventListener('close', () => this.querySelector('.cf-klarna__open')?.focus(), true);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cf-predictive-search"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cf-predictive-search')) {
  customElements.define('cf-predictive-search', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.input = this.querySelector('input[name="q"]');
      this.panel = this.querySelector('[data-cf-panel]');
      this.status = this.querySelector('[data-cf-status]');
      this.listId = this.input.getAttribute('aria-controls');
      this.version = 0;
      this.index = -1;
      this.input.addEventListener('input', () => { if (!this.composing) this.schedule(); }, options);
      this.input.addEventListener('compositionstart', () => { this.composing = true; this.close(); }, options);
      this.input.addEventListener('compositionend', () => { this.composing = false; this.schedule(); }, options);
      this.input.addEventListener('focus', () => this.schedule(), options);
      this.input.addEventListener('keydown', (event) => this.navigate(event), options);
      this.addEventListener('focusout', () => {
        setTimeout(() => { if (!this.contains(document.activeElement)) this.close(); }, 0);
      }, options);
      document.addEventListener('pointerdown', (event) => { if (!this.contains(event.target)) this.close(); }, options);
      this.querySelector('form').addEventListener('submit', () => this.close(), options);
    }
    disconnectedCallback() {
      this.close();
      this.events?.abort();
      this.events = null;
    }
    close() {
      clearTimeout(this.timer);
      this.request?.abort();
      this.version += 1;
      this.index = -1;
      this.panel.hidden = true;
      this.input.setAttribute('aria-expanded', 'false');
      this.input.removeAttribute('aria-activedescendant');
      this.input.removeAttribute('aria-busy');
      this.status.textContent = '';
    }
    schedule() {
      this.close();
      const query = this.input.value.trim();
      if (query.length < 2) return;
      const version = this.version;
      this.timer = setTimeout(() => this.load(query, version), 200);
    }
    async load(query, version) {
      this.request = new AbortController();
      this.input.setAttribute('aria-busy', 'true');
      this.status.textContent = this.dataset.loading;
      const url = new URL(this.dataset.endpoint, location.origin);
      url.search = new URLSearchParams({
        q: query,
        'resources[type]': 'product',
        'resources[limit]': '10',
        'resources[limit_scope]': 'each',
        'resources[options][unavailable_products]': 'hide',
        'resources[options][fields]': 'title,product_type,variants.title,variants.sku,vendor',
        section_id: 'cf-predictive-results'
      }).toString();
      try {
        const response = await fetch(url, { signal: this.request.signal, headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error('Search unavailable');
        const html = await response.text();
        if (version !== this.version || query !== this.input.value.trim() || !this.contains(document.activeElement)) return;
        const result = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cf-results]');
        if (!result) throw new Error('Missing search results');
        result.querySelector('[data-cf-list]').id = this.listId;
        result.querySelectorAll('[role="option"]').forEach((option, index) => { option.id = this.listId + '-' + index; });
        this.panel.replaceChildren(result);
        this.panel.hidden = false;
        this.input.setAttribute('aria-expanded', 'true');
        this.status.textContent = result.querySelector('[data-cf-announcement]').textContent;
      } catch (error) {
        if (error.name !== 'AbortError' && version === this.version) {
          this.panel.hidden = true;
          this.input.setAttribute('aria-expanded', 'false');
          this.status.textContent = this.dataset.error;
        }
      } finally {
        if (version === this.version) this.input.removeAttribute('aria-busy');
      }
    }
    navigate(event) {
      if (event.isComposing) return;
      if (event.key === 'Escape') { event.preventDefault(); this.close(); return; }
      const options = Array.from(this.panel.querySelectorAll('[role="option"]'));
      if (this.panel.hidden || !options.length) return;
      if (event.key === 'Enter' && this.index >= 0) {
        event.preventDefault();
        options[this.index].querySelector('a').click();
        this.close();
        return;
      }
      if (!['ArrowDown', 'ArrowUp'].includes(event.key)) return;
      event.preventDefault();
      this.index = event.key === 'ArrowDown' ? (this.index + 1) % options.length : (this.index <= 0 ? options.length - 1 : this.index - 1);
      options.forEach((option, index) => option.setAttribute('aria-selected', String(index === this.index)));
      this.input.setAttribute('aria-activedescendant', options[this.index].id);
      options[this.index].scrollIntoView({ block: 'nearest' });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cf-scratch-popup"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('cf-scratch-popup')) return;
  customElements.define('cf-scratch-popup', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || !this.dialog.showModal) return;
      this.preview = new URLSearchParams(location.search).get('cf_popup_preview') === '1';
      this.key = 'cf_newsletter_scratch_v1';
      this.launcher = this.querySelector('.cfsp-launcher');
      this.card = this.querySelector('[data-scratch]');
      this.canvas = this.querySelector('canvas');
      this.formPanel = this.querySelector('.cfsp-form-panel');
      this.success = !!this.querySelector('[data-success]');
      this.querySelector('.cfsp-close').addEventListener('click', () => this.closePopup());
      this.querySelector('.cfsp-dismiss').addEventListener('click', () => this.closePopup());
      this.launcher.addEventListener('click', () => this.openPopup());
      this.querySelector('.cfsp-reveal').addEventListener('click', () => this.reveal());
      this.dialog.addEventListener('cancel', e => { e.preventDefault(); this.closePopup(); });
      this.dialog.addEventListener('click', e => { if (e.target === this.dialog) { const r = this.dialog.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) this.closePopup(); } });
      this.querySelector('form')?.addEventListener('submit', () => {
        try { sessionStorage.setItem('cf_popup_submitted', '1'); } catch (_) {}
      });
      if (this.success) {
        if (!this.preview) this.remember('subscribed');
        this.openPopup(); this.reveal(); return;
      }
      if (this.querySelector('[data-errors]')) { this.openPopup(); this.reveal(); return; }
      if (this.preview) { this.openPopup(); return; }
      if (this.dataset.editor === 'true' || this.dataset.subscribed === 'true') return;
      let state;
      try { state = JSON.parse(localStorage.getItem(this.key) || 'null'); } catch (_) {}
      if (state?.type === 'subscribed') return;
      this.launcher.hidden = false;
      if (state?.type === 'dismissed' && Date.now() - state.time < 7 * 86400000) return;
      this.timer = setTimeout(() => {
        if (document.visibilityState === 'visible' && !document.querySelector('dialog[open]')) this.openPopup();
      }, 5000);
    }
    disconnectedCallback() { clearTimeout(this.timer); this.resizeObserver?.disconnect(); }
    remember(type) { try { localStorage.setItem(this.key, JSON.stringify({type, time:Date.now()})); } catch (_) {} }
    openPopup() {
      if (this.dialog.open) return;
      this.previousFocus = document.activeElement;
      this.dialog.showModal(); this.launcher.hidden = true;
      if (!this.card.classList.contains('is-revealed')) this.setupCanvas();
    }
    closePopup() {
      this.dialog.close();
      if (!this.preview && !this.success) { this.remember('dismissed'); this.launcher.hidden = false; }
      this.previousFocus?.focus();
    }
    reveal() {
      this.card.classList.add('is-revealed');
      this.formPanel.hidden = false;
      this.querySelector('.cfsp-reveal').hidden = true;
      this.querySelector('.cfsp-scratch-label').hidden = true;
    }
    setupCanvas() {
      const canvas = this.canvas;
      const draw = () => {
        if (this.card.classList.contains('is-revealed')) return;
        const r = canvas.getBoundingClientRect(); if (!r.width) return;
        const dpr = Math.min(window.devicePixelRatio || 1, 2);
        canvas.width = Math.round(r.width * dpr); canvas.height = Math.round(r.height * dpr);
        this.ctx = canvas.getContext('2d'); if (!this.ctx) { this.reveal(); return; }
        this.ctx.scale(dpr, dpr);
        const g = this.ctx.createLinearGradient(0,0,r.width,r.height);
        g.addColorStop(0,'#919d96');g.addColorStop(.35,'#bac5be');g.addColorStop(.65,'#79877e');g.addColorStop(1,'#a8b8ac');
        this.ctx.fillStyle = g; this.ctx.fillRect(0,0,r.width,r.height);
        this.ctx.strokeStyle = '#ffffff1f';this.ctx.lineWidth = 1;
        for (let i = -r.height; i < r.width; i += 8) { this.ctx.beginPath();this.ctx.moveTo(i,0);this.ctx.lineTo(i+r.height,r.height);this.ctx.stroke(); }
        this.ctx.globalCompositeOperation = 'destination-out'; this.scratched = new Set();
      };
      draw();
      if (this.boundCanvas) return;
      this.boundCanvas = true;
      this.resizeObserver = new ResizeObserver(draw); this.resizeObserver.observe(this.card);
      const scratch = e => {
        if (!this.drawing || this.card.classList.contains('is-revealed') || !this.ctx) return;
        const r = canvas.getBoundingClientRect(); const x = e.clientX-r.left, y=e.clientY-r.top;
        this.ctx.beginPath();this.ctx.arc(x,y,23,0,Math.PI*2);this.ctx.fill();
        for (let gx = Math.max(0, Math.floor((x-23)/12)); gx <= Math.min(Math.ceil(r.width/12)-1, Math.floor((x+23)/12)); gx++) {
          for (let gy = Math.max(0, Math.floor((y-23)/12)); gy <= Math.min(Math.ceil(r.height/12)-1, Math.floor((y+23)/12)); gy++) {
            if (Math.hypot(gx*12+6-x, gy*12+6-y) <= 23) this.scratched.add(gx+':'+gy);
          }
        }
        this.querySelector('.cfsp-scratch-label').hidden = true;
        if (this.scratched.size > Math.ceil(r.width/12)*Math.ceil(r.height/12)*.12) this.reveal();
      };
      canvas.addEventListener('pointerdown', e => { this.drawing=true;canvas.setPointerCapture(e.pointerId);scratch(e); });
      canvas.addEventListener('pointermove', scratch);
      canvas.addEventListener('pointerup', () => { this.drawing=false; });
      canvas.addEventListener('pointercancel', () => { this.drawing=false; });
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cf-sidebar-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('input', (event) => {
  if (!event.target.matches('[data-cf-category-search]')) return;
  const root = event.target.closest('[data-cf-side-menu]');
  const normalize = text => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  const query = normalize(event.target.value.trim());
  const details = [...root.querySelectorAll('details')];
  if (query && !root.dataset.filtering) {
    details.forEach(node => node.dataset.wasOpen = String(node.open));
    root.dataset.filtering = 'true';
  }
  root.querySelectorAll('[data-cf-menu-item]').forEach(item => {
    item.hidden = query !== '' && !normalize(item.textContent).includes(query);
  });
  if (query) details.forEach(node => { node.open = !node.closest('[data-cf-menu-item]').hidden; });
  else if (root.dataset.filtering) {
    details.forEach(node => { node.open = node.dataset.wasOpen === 'true'; delete node.dataset.wasOpen; });
    delete root.dataset.filtering;
  }
  const visible = [...root.querySelectorAll('[data-cf-menu-item]')].some(item => !item.hidden);
  root.querySelector('[data-cf-menu-empty]').hidden = visible;
});
document.addEventListener('click', (event) => {
  const openButton = event.target.closest('[data-cf-open-categories]');
  if (openButton) {
    const dialog = document.getElementById(openButton.getAttribute('aria-controls'));
    if (dialog && !dialog.open) { dialog.showModal(); openButton.setAttribute('aria-expanded', 'true'); }
  }
  const closeButton = event.target.closest('[data-cf-close-categories]');
  if (closeButton) closeButton.closest('dialog').close();
  if (event.target.matches('.cf-category-drawer')) {
    const rect = event.target.getBoundingClientRect();
    if (event.clientX > rect.right || event.clientY > rect.bottom) event.target.close();
  }
});
document.addEventListener('close', (event) => {
  if (!event.target.matches('.cf-category-drawer')) return;
  document.querySelectorAll('[data-cf-open-categories]').forEach(button => {
    if (button.getAttribute('aria-controls') === event.target.id) button.setAttribute('aria-expanded', 'false');
  });
}, true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cf-whatsapp-chat"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cf-whatsapp-chat')) {
  customElements.define('cf-whatsapp-chat', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const details = this.querySelector('details');
      const close = () => { details.open = false; this.querySelector('summary').focus(); };
      this.querySelector('[data-close]').addEventListener('click', close);
      this.addEventListener('keydown', (event) => { if (event.key === 'Escape' && details.open) close(); });
      const field = this.querySelector('textarea');
      field.addEventListener('input', () => field.setCustomValidity(''));
      this.querySelector('form').addEventListener('submit', (event) => {
        if (!field.value.trim()) {
          event.preventDefault();
          field.value = '';
          field.reportValidity();
        }
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
